import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ProjectUser } from "@iventis/domain-model/model/projectUser";
import { UserCreateRequest } from "@iventis/domain-model/model/userCreateRequest";
import { UserGroup } from "@iventis/domain-model/model/userGroup";

export interface PeopleViewMachineContext {
    people: ProjectUser[];
    selectedPeople: string[];
    projectId: string;
}

export interface NewTeamUsers {
    id: string;
    emails: string[];
    teams: UserGroup[];
    valid: boolean;
    isProjectAdmin?: boolean;
    ssoEnabled?: boolean;
}

// Do not want projectId or createCredentialsRequired and want to redefine the user to only have email property
export interface PostUserCreateRequest extends Omit<UserCreateRequest, "projectId" | "createCredentialsRequired" | "user"> {
    user: { email: string; projectAdmin?: boolean; ssoEnabled?: boolean };
}

export interface ConfirmationDialogContent {
    title: string;
    icon: IconProp;
    message: [string, string];
    toast: string;
    toastTestId?: string;
    apiCall: (userIds: string[], projectId?: string) => Promise<{ userIds: string[] }>;
    callBack?: (userIds: string[]) => void;
}

export enum PeopleViewAction {
    REMOVE = "REMOVE",
    RESET_PASSWORD = "RESET_PASSWORD",
    ENABLE_SSO = "ENABLE_SSO",
    DISABLE_SSO = "DISABLE_SSO",
}
